export default "__VITE_ASSET__C_Qc4GAp__"